// PrintBridge's /api/health (same local agent DymoPrinter.tsx uses for
// printer discovery — see PRINTBRIDGE_URL there) also reports machineName,
// so it doubles as the machine-name agent. Fetched once per page load and
// cached — every API call reuses the same value via axios-factory.ts.
const AGENT_URL = 'http://127.0.0.1:9631/api/health';

// Only a successful lookup is cached — a failed one isn't, so if the agent
// exe gets started after the page already loaded, the next API call picks
// it up instead of being stuck with null for the rest of the session.
let cachedMachineName: string | null = null;
let inFlight: Promise<string | null> | null = null;

export const getMachineName = (): Promise<string | null> => {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (cachedMachineName !== null) return Promise.resolve(cachedMachineName);
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 800);
      const res = await fetch(AGENT_URL, { signal: controller.signal });
      clearTimeout(timeoutId);
      if (!res.ok) throw new Error('system agent health check failed');
      const data = await res.json();
      cachedMachineName = data.machineName ?? null;
      return cachedMachineName;
    } catch {
      return null;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
};
